<template>
  <article>
    <template v-if="!metas.isEditable">
      <div
        class="c-comment"
        :class="[
          `c-comment--${body.user.role}`,
          {'highlight' : body.highlighted},
          {'threaded' : (body.answers.total + metas.answers.recents.length) > 0}
        ]">
        <div class="container-fluid">
          <div class="d-flex">
            <Avatar
              :role="body.user.role"
              :photo="body.user.photo"
              :name="body.user.name"
              class="c-avatar--tiny me-3">
            </Avatar>
            <div class="flex-grow-1 d-flex">
              <div class="flex-grow-1">
                <div class="d-block d-md-flex align-items-center mb-2">
                  <div class="d-flex align-items-center white">
                    <span class="w-bold">{{body.user.name}}</span>
                    <span
                      v-if="isSpecialUser"
                      class="c-comment__label ms-2 d-none d-md-inline-block"
                    >
                      {{ userRole }}
                    </span>
                    <i
                      class="ms-2"
                      :class="(body.type == 'comment') ? 'iconf-comment' : 'iconf-question'"
                    />
                  </div>
                  <i class="c-comment__dot mx-3 d-none d-md-inline-block"></i>
                  <time class="w-medium medium-gray d-block d-md-inline-block">
                    {{ commentDate }}
                  </time>
                </div>
                <p class="medium-gray w-medium mb-3">
                  {{this.body.text}}
                </p>
                <div v-if="attachments.length" class="c-comment__atachments d-flex flex-wrap">
                  <a
                    v-for="(photo, pindex) of attachments"
                    :href="photo.url"
                    :key="photo.idRemote"
                    :data-fancybox="`gallery-${body.id}`"
                    class="c-photo">
                    <div
                      v-if="pindex == 2"
                      class="c-photo__overlay position-absolute d-flex
                        justify-content-center align-items-center"
                    >
                      <span class="white fs-25 w-sbold">+ {{body.attachments.length - 2}}</span>
                    </div>
                    <img class="w-100 h-100 of--cover" :src="photo.url" alt="">
                  </a>
                  <figure
                    v-for="(photo) of hiddenAttachments"
                    :href="photo.url"
                    :key="photo.idRemote"
                    :data-fancybox="`gallery-${body.id}`"
                    class="c-photo d-none">
                    <img class="w-100 h-100 of--cover" :src="photo.url" alt="">
                  </figure>
                </div>
                <button class="c-link" @click="openEditor(true)">Responder</button>
              </div>
              <div v-if="body.user.id === Number(userData.id)">
                <Dropdown v-model="switcherActions">
                  <template v-slot:toggle>
                    <button
                      @click="switcherActions = !switcherActions"
                      class="c-link c-link--white">
                      <Icon icon="entypo:dots-three-vertical" />
                    </button>
                  </template>
                  <template v-slot:menu>
                    <ul>
                      <li>
                        <button @click="openActions('edit')" class="d-flex w-100">
                          <Icon icon="la:pen" class="fs-18 me-2" />
                          <span class="fs-14 w-sbold">Editar</span>
                        </button>
                      </li>
                      <li color="alert">
                        <button @click="openActions('delete')" class="d-flex w-100">
                          <Icon icon="ci:trash-full" class="fs-18 me-2" />
                          <span class="fs-14 w-sbold">Eliminar</span>
                        </button>
                      </li>
                    </ul>
                  </template>
                </Dropdown>
              </div>
            </div>
          </div>

          <section>
            <Editor
              v-if="metas.editor"
              mode="post"
              category="answer"
              :parent="body.id"
              :switcher.sync="metas.editor"
              :thread.sync="body.answers.data"
              :recents.sync="metas.answers.recents"
              class="c-editor--secondary mt-3"
            />

            <button
              v-if="body.answers.total > 0 && answers.length == 0"
              class="c-link mt-3 ps-3 d-flex align-items-center"
              @click="getAnswers(body.id)"
              :disabled="isLoading"
            >
              <i class="iconf-arrow-down me-2"></i>
              Ver respuestas ({{this.body.answers.total}})
            </button>
            <button
              v-if="isMoreAnswers"
              @click="getAnswers(body.id)"
              class="c-link mt-3"
              :disabled="isLoading"
            >
              <i class="iconf-arrow-curve-right me-2"></i>
              Más respuestas
            </button>
            <div v-if="answers.length > 0" class="mt-4">
              <ul class="c-comment__thread ul-reset">
                <li v-for="answer of body.answers.data" :key="answer.id">
                  <Answer :body="answer" :thread.sync="body.answers.data" />
                </li>
              </ul>
            </div>
          </section>
        </div>

        <DeleteDialog :data="deleteDialog">
          <template v-slot:navigation>
            <button
              @click="deleteDialog.switcher = false"
              class="c-button c-button--empty c-button--empty-white me-3">
              Cancelar
            </button>
            <button
              @click="deleteComment()"
              class="c-button c-button--alerts"
              :disabled="deleteDialog.isLoading"
              :class="{ 'loading' : deleteDialog.isLoading }"
            >
              {{ (deleteDialog.isLoading) ? 'Eliminando...' : 'Eliminar' }}
              <img
                class="c-button__spinner"
                src="@/assets/images/animations/spinner-white.png"
                alt="loading" />
            </button>
          </template>
        </DeleteDialog>
      </div>
    </template>
    <template v-else>
      <div class="container-fluid">
        <Editor
          mode="update"
          category="comment"
          :parent="`${body.id}Edit`"
          :switcher.sync="metas.isEditable"
          :comment="body"
          :thread.sync="localThread"
          class="c-editor--secondary mt-3"
        />
      </div>
    </template>
  </article>
</template>

<script>
/* eslint-disable */
import $ from 'jquery';
import '@fancyapps/fancybox/';
import {scroller} from 'vue-scrollto/src/scrollTo';
import { Icon } from '@iconify/vue2';
import { mapState } from 'vuex';

import Editor from './Editor.vue';
import Avatar from '../../Avatar.vue';
import Answer from './Answer.vue';
import Dropdown from '../../ui/Dropdown.vue';
import DeleteDialog from '../../ui/Dialog.vue';

const mainScroll = scroller()

export default {
  data(){
    return {
      attachments: [],
      hiddenAttachments: [],
      metas: {
        isEditable: false,
        editor: false,
        answers: {
          isLoading: false,
          currentPage: 0,
          recents: [],
        },
      },

      switcherActions: false,

      deleteDialog: {
        switcher: false,
        title: '¿Estas seguro de eliminar el comentario?',
        icon: 'iconf-trash-outlined',
        body: 'Recuerda que al eliminarlo ya no podrás recuperarlo',

        isLoading: false,
      },

      isLoading: false,
      localThread: [],
    }
  },
  components: {
    Icon,

    Editor,
    Avatar,
    Answer,
    Dropdown,
    DeleteDialog,
  },
  props: {
    thread: Array,
    answers: Array,
    threadMetas: Object,
    body: Object,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    isMoreAnswers: function() {
      return this.answers.length > 0 && this.body.answers.total / 5 > this.metas.answers.currentPage;
    },
    isSpecialUser: function() {
      return ['subscriber', 'teacher', 'education', 'teacher-pro', 'agent', 'team', 'core', 'administrator'].includes(this.body.user.role);
    },
    userRole: function() {
      let role = '';

      switch (this.body.user.role) {
        case 'subscriber':
          role = 'Premium';
          break;

        case 'teacher':
        case 'teacher-pro':
          role = 'Docente';
          break;

        case 'agent':
        case 'team':
        case 'education':
        case 'core':
        case 'administrator':
          role = 'Team Arcux';
          break;
      }

      return role;
    },
    commentDate: function() {
      if (this.body.date.includes('-')) {
        return (new Date(this.body.date)).toLocaleDateString('es', { weekday: 'long', month: 'long', day: 'numeric' });
      } else {
        return this.body.date;
      }
    },
  },
  watch: {
    body() {
      this.initAtachments();
    },
    localThread() {
      this.$emit('update:thread', this.localThread);
    },
  },
  mounted() {
    $('[data-fancybox="gallery"]').fancybox();

    this.localThread = [...this.thread];

    this.initAtachments();
  },
  methods: {
    initAtachments() {
      if (this.body.attachments.length > 2) {
        this.attachments        = this.body.attachments.slice(0, 3);
        this.hiddenAttachments  = this.body.attachments.slice(3);
      } else {
        this.attachments = this.body.attachments;
      }
    },

    openEditor: function(state){
      this.metas.editor = state;

      this.$nextTick(() => {
        mainScroll(`#editorForm${ this.body.id }`, {offset: -(window.innerHeight * 0.5)});
      })
    },
    getAnswers(parentId) {
      let nextPage  = this.metas.answers.currentPage + 1;
      let request   = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${this.$route.params.module}/${this.$route.params.lection_slug}/annotations/${parentId}/answers?page=${nextPage}&order=desc`

      request = (this.metas.answers.recents.length > 0) ? `${request}&exclude=${this.metas.answers.recents.map(ans => ans).join(',')}` : request

      this.isLoading = true;

      fetch(request)
        .then(res => {
          if(res.status == 200 || res.status < 300){
            return res.json()
          }else{
            throw res;
          }
        })
        .then(answers => {
          this.$emit(
            'update:answers',
            [
              ...answers.data,
              ...this.answers,
            ]
          )

          this.metas.answers.currentPage++;
        })
        .catch(err => {
          throw err;
        })
        .finally(() => { this.isLoading = false })
    },

    openActions(action) {
      if (action === 'edit') {
        this.metas.isEditable = true;
      } else if (action === 'delete') {
        this.deleteDialog.switcher = true;
      }

      this.switcherActions = false;
    },
    deleteComment() {
      this.deleteDialog.isLoading = true;

      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/annotations/${this.body.id}`;

      fetch(request, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then(res => {
          if(res.status == 200 || res.status < 300){
            return res.json();
          }else{
            throw res;
          }
        })
        .then(response => {
          if (response.status) {
            this.$emit(
              'update:thread',
              this.thread.filter(com => com !== this.body)
            );

            this.$emit(
              'update:threadMetas',
              {
                ...this.threadMetas,
                total: this.threadMetas.total - 1,
              },
            );
          }
        })
        .catch(err => {
          throw err;
        })
        .finally(() => {
          this.deleteDialog.isLoading = false;
        })
    },
  },
}
</script>
